
import Vue from 'vue';
import { mustache } from '@/utility/helpers';
import { transformRichText } from '~/transforms/transformComponents';
import { getTranslationString } from '~/utility/i18n';

export default Vue.extend({
  props: {
    serviceName: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      consentStatus: false,
    };
  },
  methods: {
    getUserCentricsServiceList(): { id: string; name: string; status: boolean }[] {
      if (window.UC_UI) {
        const services = window.UC_UI.getServicesBaseInfo();
        return services.map((serviceItem: any) => {
          return {
            id: serviceItem.id,
            name: serviceItem.name,
            status: serviceItem.consent.status,
          };
        });
      }
      return [];
    },
    unblockService(): any {
      this.getUserCentricsServiceList().forEach((serviceItem: any) => {
        if (serviceItem.name === this.serviceName) {
          window.UC_UI.acceptService(serviceItem.id);
        }
      });
    },
    loadOrBlockService(e: any = null) {
      const usercentricsEvents = ['DENY_ALL', 'SAVE', 'ACCEPT_ALL', 'UC_UI_INITIALIZED'];
      if (window.UC_UI) {
        this.consentStatus = this.getUserCentricsServiceList().some(
          (service: any) => service.name === this.serviceName && service.status === true
        );
      }

      if ((e && usercentricsEvents.includes((e.detail && e.detail.type) || e.type)) || !e) {
        this.$emit('consentChanged', this.consentStatus);
      }
    },
  },
  computed: {
    buttonLabel(): string {
      return getTranslationString(this.$globals, 'consentBlockerUnlock');
    },
    description(): string {
      const text = transformRichText(this.$globals.consentBlocker);
      return text ? mustache(text, { serviceName: this.serviceName }) : '';
    },
  },
  mounted() {
    this.getUserCentricsServiceList();
    this.loadOrBlockService();
    window.addEventListener('UC_UI_CMP_EVENT', this.loadOrBlockService);
    window.addEventListener('UC_UI_INITIALIZED', this.loadOrBlockService);
  },
  destroyed() {
    window.removeEventListener('UC_UI_CMP_EVENT', this.loadOrBlockService);
    window.removeEventListener('UC_UI_INITIALIZED', this.loadOrBlockService);
  },
});
